// Skip-next-turn flag. Pure. No React, no Three.js. Stamps a player's
// avatar so their NEXT turn begins and immediately passes (Vaults of
// Zul: "skip their next turn").
//
// The flag lives on the avatar card instance (already synced) as a
// JSON-safe boolean, mirroring the Waveshaper skip-untap pattern: the
// flag is SET on whichever client resolved the effect, but CONSUMED on
// the affected player's own client when their START phase runs. So it
// must be broadcast like other transient turn state.
//
// Read (mark) and consume are split so the turn runner can burn the
// flag exactly once at turn start.

export function markSkipNextTurn(avatar) {
  if (!avatar) return;
  avatar._skipNextTurn = true;
}

export function hasSkipNextTurn(avatar) {
  return avatar?._skipNextTurn === true;
}

/**
 * Consume the skip-next-turn flag. Returns true if the turn should be
 * SKIPPED (and clears the flag); false to proceed with a normal turn.
 */
export function consumeSkipNextTurn(avatar) {
  if (!avatar?._skipNextTurn) return false;
  avatar._skipNextTurn = false;
  return true;
}
